<template>
  <div class="curr-bg">
    <div class="left-title d-aligncnter">
      <img class="img-24" src="@/assets/img/cockpit/newspaper.svg" style="width: 24px; height: 24px" />
      <div class="ml-4">体测项目合格率统计</div>
    </div>
    <table class="left-table" cellspacing="0">
      <tr class="t-head">
        <td class="td-1">项目名称</td>
        <td class="td-2">合格率</td>
        <!-- <td class="td-3">历史最好成绩</td> -->
      </tr>
    </table>
    <div style="height: 227px; overflow: hidden" @mouseenter="stopScroll" @mouseleave="startScroll">
      <table class="left-table" cellspacing="0" :class="{ 'animated-top': animatedTop && this.stuData.length > 6 }">
        <tr
          class="tr-data"
          :class="{ 'color-tr': getBgClass(index) }"
          v-for="(item, index) in stuData"
          :key="'stu_' + index"
        >
          <td class="td-1">{{ item.itemName }}</td>
          <td class="college-name td-2 overflow">
            {{ item.avgScore == '-' ? '-' : (item.avgScore * 100).toFixed(2) + '%' }}
          </td>
          <!-- <td class="td-3">{{ item.maxScore }}</td> -->
        </tr>
      </table>
    </div>
  </div>
</template>
<script>
export default {
  props: ['itemData'],
  data() {
    return {
      stuData: [],
      animatedTop: false,
      timer: null,
      flag: true,
    }
  },
  watch: {
    itemData: {
      handler: function () {
        // this.stopScroll()
        this.stuData = this.itemData
        // setTimeout(() => {
        //   this.startScroll()
        // }, 2000)
      },
      deep: true,
    },
  },
  created() {
    this.stuData = this.itemData
  },
  mounted() {
    // const that = this
    // setTimeout(() => {
    //   for (let i = 0; i < that.stuData.length; i++) {
    //     that.stuData[i].code = i + 1
    //   }
    // }, 2000)
    this.timer = setInterval(() => {
      if (this.stuData.length > 6) {
        this.animatedTop = true
        setTimeout(() => {
          this.stuData.push(this.stuData[0])
          this.stuData.shift()
          this.animatedTop = false
        }, 500)
      } else {
        this.stopScroll()
      }
    }, 2000)
  },
  computed: {
    getBgClass() {
      return function (index) {
        if (index % 2 == 0) {
          return false
        }
        return true
      }
    },
  },
  methods: {
    stopScroll() {
      console.log('stopScroll')
      clearInterval(this.timer)
      this.timer = null
    },
    startScroll() {
      console.log('startScroll')
      this.timer = setInterval(() => {
        if (this.stuData.length > 6) {
          this.animatedTop = true
          setTimeout(() => {
            this.stuData.push(this.stuData[0])
            this.stuData.shift()
            this.animatedTop = false
          }, 500)
        } else {
          this.stopScroll()
        }
      }, 2000)
    },
  },
}
</script>
<style scoped lang="scss">
@import '@/assets/css/academic.scss';
.animated-top {
  transition: all 0.5s;
  margin-top: -34px;
}
.left-title {
  font-size: 22px;
  margin-bottom: 8px;
}
.left-box {
  width: calc(100% - 48px);
  margin-left: 24px;

  .left-table {
    width: calc(100% - 0px);
    font-size: 16px;
    white-space: nowrap;
    overflow: hidden;
    border-radius: 4px;
  }
}
table {
  table-layout: fixed;
  width: 100%;
  tr td {
    text-align: center;
    height: 34px;
    // height: 3vh;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .t-head {
    width: 100%;
    background: linear-gradient(0deg, rgba(6, 88, 58, 0.0884779) -24.83%, #06583a 100%);
    height: 36px;
    // height: 4vh;
  }
  tr {
    width: 100%;
    .td-1 {
      width: 40%;
    }
    .td-2 {
      width: 30%;
    }
    .td-3 {
      width: 30%;
    }
    .td-4 {
      width: 30%;
    }
  }
  .color-tr {
    background: rgba(0, 122, 77, 0.2);
  }
  //   .tr-data {
  // .college-name {
  //   text-align: left;
  // }
  //   }
}
.curr-bg {
  margin: 16px;
  padding: 16px;
  //   height: 28vh;
  height: 287px;
  background: linear-gradient(0deg, rgba(0, 122, 77, 0.1) 80%, rgba(0, 122, 77, 0.1) 100%);
  padding: 16px;
}
</style>
